/**
 * Axios API Client
 * Configures and exports a reusable Axios instance for API requests.
 * 
 * Main logic:
 * - Set base URL and default headers.
 * - Add interceptors for error handling and auth if needed.
 * 
 * All variable names, logs, and comments are in English.
 */

import axios, { AxiosError, AxiosResponse } from "axios";
import debugLogger from '@/lib/utils/debugLogger';

// Create axios client with base configuration
const axiosClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL || '',
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for logging and modifying requests
axiosClient.interceptors.request.use(
  (config) => {

    return config;
  },
  (error) => {
    debugLogger.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for logging and handling responses
axiosClient.interceptors.response.use(
  (response) => {

    return response;
  },
  (error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      debugLogger.error(`API Error: ${error.response.status}`, error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      debugLogger.error('API Error: No response received', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('API Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
